import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-settlement-documents',
  templateUrl: './settlements.component.html',
})
export class SettlementsComponent implements OnInit {

  constructor(
    private authService: AuthService,
  ) {

  }
  ngOnInit() {
  }

  getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
    return this.authService.getModuleGroupAndModuleAccess(moduleName, groupName);
  }



}
